/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Title2Inputs */

const vi_cmspostcategory_title2 = /** @type {(inputs: Cmspostcategory_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyên mục tin tức`)
};

/**

* @param {Cmspostcategory_Title2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_title2 = /** @type {((inputs?: Cmspostcategory_Title2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Title2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_title2(inputs)
});
export { cmspostcategory_title2 as "cmsPostCategory_title" }